// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"255f8cf2","455":"d1fddc90","977":"8e62fad5"}[chunkId] + ".chunk.js";
};